import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { userVerifyEmail } from '../../../../actions/user.js';
import { displayGlobalMessage, hideGlobalMessage } from '../../../../actions/globalMessage.js';
import { authorize } from '../../../../businessLogic/authorizator.js';
import { ValidMe, forceValidation } from '../../../../businessLogic/validation.js';
import Txt from '../../../inputs/textInput.js';
import ShowOrHidePassText, { PasswordHint } from 'businessLogic/showOrHidePassText.js';

const VerifyChange = (props) => {
  const dispatch = useDispatch();
  const [keepMeLoggedIn, setKeepMeLoggedIn] = useState(false);
  const [verifyClasses, setVerifyClasses] = useState(
    'ui labeled icon button color-button color-button-hover color-white  left-text max-width '
  );
  const [enableTimerValidation, setEnableTimerValidation] = useState(false);
  const [showPasswordHint, setPasswordHint] = useState(false);
  const fetchingLogin = useSelector((state) => state.usersReducer.fetchingLogin);
  const fetchingUserProfileAfterLogin = useSelector((state) => state.usersReducer.fetchingUserProfileAfterLogin);
  const userHasWaitingAreas = useSelector((state) => state.usersReducer.userHasWaitingAreas);
  const newEmail = useSelector((state) => state.usersReducer.newEmail);

  React.useEffect(() => {
    if (fetchingLogin || fetchingUserProfileAfterLogin) {
      setVerifyClasses(verifyClasses + ' loading');
    } else {
      setVerifyClasses(verifyClasses.replace(' loading'));
    }

    if (fetchingUserProfileAfterLogin === true && userHasWaitingAreas === false) {
      setVerifyClasses(setVerifyClasses.replace(' loading', ' error-shaking'));
      setTimeout(() => {
        //remove effect after 200ms
        setVerifyClasses(setVerifyClasses.replace(' error-shaking'));
      }, 200);
    }
  }, [fetchingLogin, fetchingUserProfileAfterLogin]);

  React.useEffect(() => {
    window.$(document.body).on('keydown', handleEnterForVerifyEmail);
    return () => {
      window.$(document.body).off('keydown', handleEnterForVerifyEmail);
    };
  }, []);

  const handleKeepMeSignedInChange = () => {
    setKeepMeLoggedIn(!keepMeLoggedIn);
  };

  const handlePasswordChange = () => {
    setEnableTimerValidation(true);
  };

  const handleLoginButtonClick = (e) => {
    dispatch(hideGlobalMessage());
    window.fetchPromiseController = null;
    let areThereErrors = forceValidation(undefined, undefined, 'verifyEmailForm');
    if (!areThereErrors) {
      let callback = (data) => {
        let doNotRedirect = true;
        setPasswordHint(false);
        authorize(data, dispatch, doNotRedirect);
        dispatch(
          displayGlobalMessage({
            text: APP.LANGUAGE.ChangeEmail.SuccessVerifyEmailMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
      };

      let error = () => {
        dispatch(
          displayGlobalMessage({
            text: APP.LANGUAGE.Login.LoginError.replace(
              '##IncorrectMaxLoginAttempts##',
              window.APP.CONFIGURATION.INCORRECT_MAX_LOGIN_ATTEMPTS || 3
            ),
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
          })
        );
        setPasswordHint(true);
        setVerifyClasses(verifyClasses + ' error-shaking');
        setTimeout(() => {
          //remove effect after 200ms
          setVerifyClasses(verifyClasses.replace(' error-shaking', '').replace('loading', ''));
        }, 200);
        window.$('#overlay').hide();
      };

      dispatch(
        userVerifyEmail(
          {
            username: getUserName(),
            password: getPassword(),
            rememberMe: keepMeLoggedIn,
          },
          callback,
          error
        )
      );
    }
  };

  const getUserName = () => document.getElementById('usernameInput').value;

  const getPassword = () => document.getElementById('passwordInput').value;

  const handleEnterForVerifyEmail = (event) => {
    if (event.which == 13 && props.showForgetPasswordModal != true)
      window.$('button[data-group="verifyEmailForm"]').click();
  };

  const openPageHelp = () => {
    window.open(APP.EXTERNAL_LINKS.Login.ChangeEmail, '_blank');
  };

  return (
    <div className="login verify-email">
      {!window.hideUnfinishedItems ? (
        <i onClick={openPageHelp} className="ui icon help circle fr text-size-xl mrts mrrl hand color-white" />
      ) : (
        ''
      )}
      <form
        className="ui form "
        onSubmit={() => {
          return false;
        }}
      >
        <img className="ui image mrbxl" src={window.APP.IMAGES.ApplicationLogo} />

        <ValidMe
          validmefor="email"
          group="verifyEmailForm"
          fieldClasses=" pdbxs"
          enableTimerOnInitalRender={enableTimerValidation}
          requiredCustomMessage={window.APP.LANGUAGE.Errors.EnterYourEmail}
        >
          <Txt
            focusme="true"
            id="usernameInput"
            tabIndex="1"
            noTitle
            disabled={true}
            placeholder={APP.LANGUAGE.Login.EmailPlaceholder}
            value={newEmail}
            classes="max-width "
          />
        </ValidMe>
        <ValidMe
          validmefor="required"
          group="verifyEmailForm"
          fieldClasses={showPasswordHint ? ' mrbxs' : ''}
          enableTimerOnInitalRender={enableTimerValidation}
          requiredCustomMessage={window.APP.LANGUAGE.Errors.EnterYourPassword}
        >
          {showPasswordHint && getPassword() !== '' ? <ShowOrHidePassText elementId="passwordInput" /> : <div />}
          <Txt
            // ref={(input) => {
            //   PasswordInput = input;
            // }}
            id="passwordInput"
            tabIndex="2"
            noTitle
            onChange={handlePasswordChange}
            placeholder={APP.LANGUAGE.Login.PasswordPlaceholder}
            classes="max-width "
            type="password"
          />
        </ValidMe>
        {showPasswordHint ? <PasswordHint showPasswordHint={showPasswordHint} /> : ''}
        <Txt
          checkbox
          tabIndex="3"
          onChange={handleKeepMeSignedInChange}
          text={APP.LANGUAGE.Login.KeepMeLoggedIn}
          classes="mrbm "
        />

        <button
          tabIndex="4"
          type="button"
          onClick={handleLoginButtonClick}
          data-group="verifyEmailForm"
          className={verifyClasses}
        >
          <i className="sign in icon" />
          {APP.LANGUAGE.Login.LoginButton}
        </button>
        <div className="center-with-margin margin-footer">
          <img className="ui image footer-img" src={window.APP.IMAGES.FooterLogoImg} />
          <a
            tabIndex="7"
            className="mrrs mrtm footer-text color-footer-links"
            href={window.APP.EXTERNAL_LINKS.Login.FooterHyperLink}
            target="_blank"
          >
            {window.APP.EXTERNAL_LINKS.Login.FooterText}
          </a>
        </div>
      </form>
    </div>
  );
};

export default VerifyChange;
